/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_CLIENTS(state, clients) {
        state.clients = clients
    },
    REMOVE_RECORD(state, itemId) {
        const clientIndex = state.clients.findIndex((u) => u.ClientId === itemId)
        state.clients.splice(clientIndex, 1)
    }
}